var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvanti = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "CB15EB75-B16F-43EB-A562-A915054F9110")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.6410473%",
    y1: "50.3589527%",
    x2: "0.358952703%",
    y2: "50.3589527%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0039CB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Settings---03",
    transform: "translate(-516.000000, -410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(486.000000, 386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(30.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,33.4035088 L16.6876869,0 L17.312429,0 L34,33.4035088 L27.218012,33.4035088 L24.6746507,28.1485254 C22.0744945,22.4251399 19.4743384,16.7016357 16.8741823,10.9782502 C13.5101948,18.4533364 10.1462073,25.9283039 6.78233568,33.4035088 L0,33.4035088 Z",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "url(#linearGradient-1)",
    points: "11.3956044 28.9316756 22.6043956 28.9497076 16.9229338 17.2584795"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvanti, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Avanti.a79ff682.svg";
export { ForwardRef as ReactComponent };